"use strict";
/**
 * WHICH FAMILY A SERVICE BELONGS TO — Lab, Radiology, or everything else.
 *
 * Pure by construction: no Prisma, no tenant, no clock. That is what lets the
 * SAME module run in the browser (the catalogue's Lab and Radiology tabs, the
 * IP charge grid) and on the server (the staff discount, which must compute the
 * figure itself). One implementation, so the family the operator was shown and
 * the family the discount was applied against cannot disagree.
 *
 * IT MOVED HERE FROM THE FRONTEND. `features/department-billing/family-prefixes`
 * held this list, and the browser was its only reader — fine while the only
 * question was which tab to show. The staff discount asks the same question on
 * the SERVER, where the amount is decided, and a second copy of the prefixes
 * there would drift: the symptom would be a service discounted at one rate on
 * screen and another on the invoice.
 *
 * ── WHAT A PREFIX IS A PREFIX OF ──────────────────────────────────────────
 *
 * The identifier is `servCode` + `servNumber` across two columns, so a prefix
 * that stops inside the letters is a prefix on `servCode` alone. Callers pass
 * the JOINED identifier ("BCB2", "XRF1"), which is what both the catalogue row
 * and the ledger snapshot carry.
 *
 * ── AND WHAT IT DELIBERATELY DOES NOT CLAIM ───────────────────────────────
 *
 * This separates LAB from RADIOLOGY. It says nothing about the DISCIPLINE
 * inside lab — the third character is partly an alphabetical bucket rather
 * than a specialty, so `BCB*` is not "biochemistry B". Anything needing the
 * discipline must read the catalogue, not this.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAMILY_PREFIXES = void 0;
exports.classifyServiceFamily = classifyServiceFamily;
exports.FAMILY_PREFIXES = {
    LAB: ['BC', 'CP', 'HP', 'MB', 'SP'],
    RADIOLOGY: ['XR'],
};
/**
 * Classify one service by its identifier.
 *
 * Case-insensitive because the identifier reaches this from three places — a
 * catalogue row, a draft line and a ledger snapshot — and only one of them is
 * guaranteed upper-case. A null or empty identifier is `OTHER`: an unclassified
 * service is not a lab test, and guessing otherwise would hand a 30% staff
 * concession to a line nobody classified.
 */
function classifyServiceFamily(identifier) {
    const code = (identifier ?? '').trim().toUpperCase();
    if (!code)
        return 'OTHER';
    if (exports.FAMILY_PREFIXES.LAB.some((prefix) => code.startsWith(prefix.toUpperCase())))
        return 'LAB';
    if (exports.FAMILY_PREFIXES.RADIOLOGY.some((prefix) => code.startsWith(prefix.toUpperCase())))
        return 'RADIOLOGY';
    return 'OTHER';
}
//# sourceMappingURL=service-family.js.map